import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { BonusSystemDetailService } from "./bonusSystemDetail.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RatingService } from "../../services/rating.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { LikeService } from "../../services/like.service";
import { Location } from "@angular/common";
import { Subscription } from "rxjs";
import { BonusactionBenefitViewModel, BonusactionDetailViewModel } from "../../shared/models/bonussystem.model";
import { WebvoucherDetailService } from "../webvoucherDetail/webvoucherDetail.service";
import { ContentType, SnackBarMessageType } from "../../shared/contentTypes";
import { LocationService } from "../location/location.service";
import { UserWebvoucherViewModel } from "../../shared/models/userInfo.model";
import { WebVoucherNumberLength } from "../../shared/models/web_voucher.model";
import { environment } from "../../../../environments/environment";
import { CoreLanguageService } from "../../services/language.service";
import { QRCode } from "../../forked/qr_code";
import { UserHelperService } from "../../services/userHelper.service";
import { CoreCOMService } from "../../services/com.service";
import { SafeHtml, DomSanitizer } from "@angular/platform-browser";
import { floatingText } from "../../shared/animation/component.animation";
import { RouterHelperService } from "../../services/routerHelper.service";
import { RatingDialogComponent } from "../../modalDialogs/ratingdialog/ratingDialog.component";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { WebvoucherDialogComponent } from "../../modalDialogs/webvoucherDialog/webvoucherDialog.component";
import { BonusWebvocherDialogComponent } from "../../modalDialogs/bonusWebvocherDialog/bonusWebvocherDialog.component";
import { WebShopService } from "../../services/webShop.service";
import { RedeemBenefitDialogComponent } from "../../modalDialogs";
import { IBenefitCacheEntry } from "../../services/IWebShopService";
import { BenefitRedemptionService } from "../../services/benefitRedemption.service";


@Component({
  selector: "bonussystemdetail",
  templateUrl: "./bonusSystemDetail.component.html",
  styleUrls: ["./bonusSystemDetail.component.scss"],
  providers: [BonusSystemDetailService, LocationService, OverlaySpinnerService, WebvoucherDetailService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [floatingText]
})
export class BonusSystemDetailComponent implements OnInit, OnDestroy {

  // set animation movement
  public floatingTextActivated: boolean = false; // to activate animation if header in wider then the width of page.
  public animationObject = { value: "left", params: { shiftPixels: "0px", initialShift: "0px", initialtime: "0s", startPosition: "0px" } };
  private shiftPixels = 0; // used for shift pixel in floating animation
  private activeInterval: boolean = true; // to start Interval after loading page
  public fullpercent: number = 100;

  public hasData: boolean = true; // check if there is data for this page;
  public panelOpenState: boolean = false;
  public hasBenefit: boolean;
  public isOnline: boolean;
  public hasLikedList: boolean = false;
  public bonusactionDetailViewModel: BonusactionDetailViewModel = new BonusactionDetailViewModel();
  public userWebvoucherViewModel: UserWebvoucherViewModel = new UserWebvoucherViewModel();
  public likedLocations: number[] = [];
  public contentType = ContentType;
  public wevoucherqrcodesvg: SafeHtml; // used to show and hide barcode at the top of the page
  private bonusActionId: number | string;
  private _langSubscriber: Subscription;
  private _ratingChangesSubscriber: Subscription;

  private _product_id: number;
  private _bonusFilterLocationIds: number[] = [];

  constructor(private _bonusSystemDetailService: BonusSystemDetailService
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreComService: CoreCOMService
    , private _sanitized: DomSanitizer
    , private _coreLanguageService: CoreLanguageService
    , private _activatedRoute: ActivatedRoute
    , private _ratingService: RatingService
    , private _snackBarService: SnackBarService
    , private _userHelperService: UserHelperService
    , private _webvoucherDetailService: WebvoucherDetailService
    , private _likeService: LikeService
    , private _location: Location
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _routerHelperService: RouterHelperService
    , private _router: Router
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _webShopService: WebShopService
    , private _benefitRedemptionService: BenefitRedemptionService) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("BonusSystemDetailComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.isOnline = me._coreComService.environment.networkInformation.isOnline;

    me._activatedRoute.paramMap.subscribe(params => {
      me.bonusActionId = params.get("id");
    });

    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._bonusSystemDetailService.ObserveChanges.subscribe(change => {
      me.reloadDataAndRender();
    });

    if (me._userHelperService.IsRegistered) {
      me.getWebvoucherViewModel();
    } else {
      // webvoucher won't be shown at the top of the page.
    }
    me.setRatingSubscriber();
    me.getLikedLocation();
    me.reloadDataAndRender();
  }

  /** Anzeige der Teilnehmenden Standorte */
  public showBonusLocation(): boolean {
    // die Anzeige wird nur von einem Kunden momentan nicht gewünscht, darum die Anpassung
    // dass es aus dem Envoirment ein besondere Variable prüft
    return environment["DISABLE_LOCATION_SELECTION_IN_BONUSSYSTEM"] ? false : true;
  }

  // check, if one rating of an item has been changed, then reload the view, with new data
  private setRatingSubscriber() {
    const me = this;
    me._ratingChangesSubscriber = me._ratingService.ObserveChanges.subscribe((changedRatings) => {
      let bonusActionRatingChanged = false;
      const bonusActionKeyPrefix = ContentType.Bonussystem + "|";
      for (const changedRating of changedRatings) {
        if (changedRating.toString().startsWith(bonusActionKeyPrefix)) {
          bonusActionRatingChanged = true;
          break;
        }
      }
      if (bonusActionRatingChanged) {
        me.reloadDataAndRender();
      }
    });
  }

  private getWebvoucherViewModel(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._webvoucherDetailService.GetWebvoucherQRCode()
      .then((response) => {
        if (response && response.webvoucherNumber) {
          me.userWebvoucherViewModel = response;
          const webvoucherNumber = response.webvoucherNumber.trim();
          if (webvoucherNumber.length == WebVoucherNumberLength) {
            me.wevoucherqrcodesvg = me._sanitized.bypassSecurityTrustHtml(new QRCode(webvoucherNumber)
              .svg());
            // todo display brightness
          }
          me.PushChanges();
        } else {
          // No webvoucher found for user;
        }
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch((e) => {
        me._coreLogService.error("BonusSystemDetailComponent.getWebvoucherViewModel", "webvoucherDetailService.GetWebvoucherQRCode", e);
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(7);
      });
  }


  public async handleBenefitRedemption(benefit: BonusactionBenefitViewModel, bonusaction: BonusactionDetailViewModel) {
    const me = this;
    const canRedeemBenefitOnline = await me._benefitRedemptionService.canRedeemBenefitOnline();
    if (canRedeemBenefitOnline) {
      me.selectRedeemBenefitOptions(benefit, bonusaction);
    } else {
      me.openQRCodeDialog();
    }
  }

  private openQRCodeDialog() {
    const me = this;
    const webvoucherModal = me._bottomSheetHelperService.open(BonusWebvocherDialogComponent, {
      data: me.userWebvoucherViewModel,
      autoFocus: false
    });

    webvoucherModal.afterDismissed().subscribe((response: boolean) => {
      if (response) {
        me.OpenWebVoucherModal();
      } else {
        // the modal dialog has been closed; Do nothing.
      }
    });
  }

  private OpenWebVoucherModal() {
    const me = this;
    const webvoucherModal = me._bottomSheetHelperService.open(WebvoucherDialogComponent, {
      data: me.userWebvoucherViewModel.webvoucherNumber,
      autoFocus: false
    });
    webvoucherModal.afterDismissed().subscribe((promise: Promise<boolean>) => {
      if (promise) {
        promise
          .then((response) => {
            if (response) {
              me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
              me.userWebvoucherViewModel.webvoucherQRCode = "";
              me.PushChanges();
            } else {
              me._snackBarService.ShowErrorMessageFailed(8);
            }
          })
          .catch((e) => {
            me._coreLogService.error("BonusSystemDetailComponent.openWebVoucherModal", "webvoucherModal.afterClosed (catch)", e);
            me._snackBarService.ShowErrorMessageFailed(9);
          });
      } else {
        // the modal dialog has been closed; Do nothing.
      }
    });
  }

  /**
   * set Interval to chack bonus point changes
   */
  private refreshBonusAction() {
    const me = this;
    if (me.activeInterval) {
      me._routerHelperService.AddInterval(setInterval(function () {
        me._bonusSystemDetailService.BonusActionDetailInterval(me.bonusactionDetailViewModel)
          .then(response => {
            // bonusactionDetailViewModel has been updated
            me.PushChanges();
          })
          .catch(e => {
            me._coreLogService.error("BonusSystemDetailComponent.refreshBonusAction", "BonusActionInterval", e);
          });
      }, environment.BonusActionInterval));
      me.activeInterval = false;
    }
  }

  /**
* get liked location by user; It affect on locationlist in expantsion panel
* like locations will be shown in list with red color(red base on customer color list)
*/
  private getLikedLocation(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._likeService.GetContentIDForActiveLikes(ContentType.Location)
      .then((locationIDs) => {
        if (locationIDs && locationIDs.length > 0) {
          me.likedLocations = locationIDs;
          me.hasLikedList = true;
          me.PushChanges();
        }
        me._overlaySpinnerService.HideLayoutSpinner();
      }).catch((e) => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreLogService.error("BonusSystemDetailComponent.getLikedLocation", "GetContentIDForActiveLikes", e);
        me._snackBarService.ShowErrorMessageFailed(10);
      });
  }

  private reloadDataAndRender(): void {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._bonusSystemDetailService.GetBonusActionDetailViewModel(me.bonusActionId)
      .then(bonusAction => {
        if (bonusAction) {
          me.bonusactionDetailViewModel = bonusAction;
          me.hasData = true;
          bonusAction.benefits && bonusAction.benefits.length > 0 ? me.hasBenefit = true : me.hasBenefit = false;
          for (const location of bonusAction.locations) {
            me._bonusFilterLocationIds.push(location.hyp_cus_nr);
          }
          me.checkBenefitInBasketAndSetValues();
          me.refreshBonusAction();
          me.PushChanges();
        } else {
          me.bonusactionDetailViewModel = new BonusactionDetailViewModel();
          me.hasData = false;
        }
        me.initialAnimation();
        me._overlaySpinnerService.HideLayoutSpinner();
      })
      .catch((e) => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._coreLogService.error("BonusSystemDetailComponent.ReloadDataAndRender", "GetBonusActionDetailViewModel", e);
        me._snackBarService.ShowErrorMessageFailed(11);
      });
  }

  public createBonusActionPointsText(points: number) {
    const me = this;
    return me._coreLanguageService.value("phBonusAction_Cost_Points").replace("<points>", points.toString());
  }

  /**
  * Open a ModalDialog for rating an item or watching item rating info
  * @param news is empty if there is no rating yet. sending item Id and contentType to show rating data in modalDialog if user rate this item before.
  */
  public openRateModel(): void {
    const me = this;
    const ratingModel = me._bottomSheetHelperService.open(RatingDialogComponent, {
      data: { contentId: me.bonusactionDetailViewModel.id, contentType: ContentType.Bonussystem, title: me.bonusactionDetailViewModel.labelDE },
    });
    // show snackBar after rating Item
    ratingModel.afterDismissed().subscribe((result: any) => {
      if (result) {
        result
          .then(() => { me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful); })
          .catch(() => { me._snackBarService.ShowErrorMessageFailed(12); });
      }
    });
  }

  /** check if benefit product is in basket and set values*/
  private checkBenefitInBasketAndSetValues() {
    this._benefitRedemptionService.updateBenefitBasketStatus(this.bonusactionDetailViewModel);
  }

  /**
   * Check whether a user can book a benefit more than once. 
   * @currentPoints user bonus points
   * @pointsInBasket points in basket (benefit cost)
   * @param benefitCost benefit cost
   * @returns Boolean value, depending on the remaining points
   */
  public canRedeemAgain(benefitCost: number) {
    const me = this;
    return me._benefitRedemptionService.canRedeemAgain(me.bonusactionDetailViewModel.points, me.bonusactionDetailViewModel.pointsInBasket, benefitCost);
  }

  /**Show hint if there are points in basket*/
  public showPointsInBasketLabel(pointsInBasket: number) {
    return this._benefitRedemptionService.showPointsInBasketLabel(pointsInBasket);
  }

  /** Hint about costs(points) for the benefit products in basket */
  public pointsInBasketLabel(currentPoints: number, benefitCostinBasket: number) {
    const me = this;
    return me._benefitRedemptionService.pointsInBasketLabel(currentPoints, benefitCostinBasket);
  }

  /**
   * @remainingPoints Points that will be remain after the purchase
   * @param benefitCost benefit cost (points)
   * @returns percentage
   */
  public BenefitInBasketPercentage(benefitCost: number) {
    const me = this;
    return me._benefitRedemptionService.benefitInBasketPercentage(benefitCost, me.bonusactionDetailViewModel.points, me.bonusactionDetailViewModel.pointsInBasket);
  }

  /**
     * redeem option depending on user points and required points
     * @param requiredPoints required points for benefit
     * @param userPoints user points for single Benefit
     * @param product_id  benefit product id
     */
  private selectRedeemBenefitOptions(benefit: BonusactionBenefitViewModel, bonusaction: BonusactionDetailViewModel) {
    const me = this;
    const canRedeemPoints = bonusaction.points >= benefit.cost;
    if (canRedeemPoints) {
      const isValid = me._benefitRedemptionService.handleConsumedPointsValidation(benefit.cost, bonusaction.points, bonusaction.pointsInBasket);
      if (!isValid) { return; }

      const benefitData = me._benefitRedemptionService.createBenefitCacheEntry(benefit);
      me._product_id = benefit.product_id;
      me._openSelectRedeemOptionDialog(benefitData);
    } else {
      me.openQRCodeDialog();
    }
  }

  /** redeem at place or online */
  private _openSelectRedeemOptionDialog(benefitData: IBenefitCacheEntry) {
    const me = this;
    const dialogRef = me._bottomSheetHelperService.open(RedeemBenefitDialogComponent, {
    });
    dialogRef.afterDismissed().subscribe(async (result) => {
      if (result === "store") {
        me.openQRCodeDialog();
      } else if (result === "online") {
        await me.startRedeemProcess(benefitData);
        me.PushChanges();
      } else {
        // do nothing
      }
    });
  }

  /**case location and order mode are selected
   * case location and order mode are not selected */
  public async startRedeemProcess(benefitData: IBenefitCacheEntry) {
    const me = this;
    await me._benefitRedemptionService.startRedeemProcess(me._product_id, me._bonusFilterLocationIds, benefitData);
    me.PushChanges();
  }

  /**
  * initial animation after page loading
  */
  private initialAnimation() {
    const me = this;
    setTimeout(() => {
      const headerTitleContainerElement: HTMLElement = document.getElementById("headerTitleContainer");
      const headerTitleElement: HTMLElement = document.getElementById("headerTitle");
      const shiftPixels = headerTitleContainerElement.clientWidth - headerTitleElement.clientWidth;
      if (shiftPixels < 0) {
        me.floatingTextActivated = true;
        me.shiftPixels = shiftPixels; // 20 = padding
        me.animationObject = {
          value: "right", params: {
            shiftPixels: `${(me.shiftPixels / 2) - 20}px` // 20 is padding in header-title class
            ,
            initialShift: `${((me.shiftPixels * (-1)) / 2) + 10}px`,
            initialtime: "3s",
            startPosition: "0px"
          }
        };
        me.PushChanges();
      }
    }, 500);
  }
  /**
  * creating infinite animation in angular
  * @param event animation event object
  */
  public onAnimateDone(event) {
    const me = this;
    if (event.toState === "right") {
      me.animationObject = {
        value: "left", params: {
          shiftPixels: `${(me.shiftPixels / 2) - 20}px`
          , initialShift: `${((me.shiftPixels * (-1)) / 2) + 10}px`
          , initialtime: "0s"
          , startPosition: `${((me.shiftPixels * (-1)) / 2) + 10}px`
        }
      };
      me.PushChanges();
    } else {
      me.animationObject = {
        value: "right", params: {
          shiftPixels: `${(me.shiftPixels / 2) - 20}px`
          , initialShift: `${((me.shiftPixels * (-1)) / 2) + 10}px`
          , initialtime: "0s"
          , startPosition: `${((me.shiftPixels * (-1)) / 2) + 10}px`
        }
      };
      me.PushChanges();
    }
  }

  public locationPanel(): void {
    const me = this;
    me.panelOpenState = !me.panelOpenState;
    me.PushChanges();
  }

  public navigateBack(): void {
    this._routerHelperService.navigateBackSimple();
  }

  public showLikedList(): void {
    const me = this;
    me.hasLikedList = false;
    me.PushChanges();
  }

  public hideLikedList(): void {
    const me = this;
    me.hasLikedList = true;
    me.PushChanges();
  }

  public swipeLeftHandler() {
    const me = this;
    me._location.back();
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe();
    }
    if (me._ratingChangesSubscriber) {
      me._ratingChangesSubscriber.unsubscribe();
    }
  }
}
